module.exports = __webpack_public_path__ + "static/media/fixed.24ff2d37.svg";